// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"location-item_wrapper__3fC5l","name":"location-item_name__tRRt7","address":"location-item_address__38--r","link":"location-item_link__hCKZb"};